export default "__VITE_ASSET__9jVzvlBZ__"